module.exports = __webpack_public_path__ + "bdfe41532e60c7b1591b4ade41650f36.svg";